function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "70px",
    width: "70px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E35336"
    },
    d: "M435.2,59.733H76.8c-42.348,0-76.8,34.452-76.8,76.8v238.933c0,42.348,34.452,76.8,76.8,76.8h358.4 c42.348,0,76.8-34.452,76.8-76.8V136.533C512,94.186,477.548,59.733,435.2,59.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D93C1C"
    },
    d: "M460.8,426.667h-384c-28.277,0-51.2-22.923-51.2-51.2V110.933c0-14.622,4.089-28.287,11.181-39.921 C14.739,84.526,0,108.838,0,136.533v238.933c0,42.348,34.452,76.8,76.8,76.8h358.4c27.695,0,52.007-14.738,65.521-36.781 C489.087,422.578,475.422,426.667,460.8,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M363.051,248.845L192.384,137.911c-5.577-3.626-13.184,0.523-13.184,7.155v221.867 c0,6.625,7.602,10.782,13.184,7.155l170.667-110.933C368.138,259.849,368.139,252.151,363.051,248.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M204.8,145.983l-12.416-8.07c-5.577-3.626-13.184,0.523-13.184,7.155v221.867 c0,6.625,7.602,10.782,13.184,7.155l12.416-8.07V145.983z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeSvgrepoCom);
export default __webpack_public_path__ + "static/media/youtube-svgrepo-com.7347d541305f8cb99556dff9226f9d62.svg";
export { ForwardRef as ReactComponent };